<div class="row">
  <div class="col-sm-12">
    <h1>{{ 'metadata' | translate }}</h1>
  </div>
</div>
<div class="row">
  <div class="col-sm-12">
    <metadata-table [tasks]="tasks"></metadata-table>
  </div>
</div>